<script>
	import { Button } from '$lib/components/ui/button';
	import { handleAnchorClick } from '$lib/components/golf/scroll';
</script>

<section class="relative bg-[#194139] pb-32 pt-16 lg:pt-24">
	<div
		class="absolute -top-48 left-0 z-10 h-48 w-full"
		style="clip-path: polygon(27% 94%,66% 86%,100% 91%,100% 100%,0 100%,0 88%);"
	>
		<div class="h-full bg-[#194139]"></div>
	</div>
	<div
		class="absolute bottom-0 left-0 z-10 h-48 w-full"
		style="clip-path: polygon(27% 94%,66% 86%,100% 91%,100% 100%,0 100%,0 88%);"
	>
		<div class="h-full bg-white"></div>
	</div>

	<div class="relative z-20 mx-auto max-w-3xl px-4 text-center">
		<p class="text-sm font-semibold uppercase tracking-widest text-[#ffd451]">
			Come for the golf. Leave with the stories.
		</p>
		<h2
			class="mt-4 text-balance font-heading text-4xl font-semibold tracking-tight text-white sm:text-5xl"
		>
			This is Tasmania. This is golf. This is a Legend.
		</h2>
		<p class="mx-auto mt-6 max-w-2xl text-pretty leading-8 text-white/85">
			Legends of Tasmania brings together world-class golf, fascinating history, great Tasmanian
			hospitality and a group of like-minded travellers — all with a little friendly competition
			along the way.
		</p>

		<div class="mx-auto mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
			<Button
				data-sveltekit-noscroll
				onclick={handleAnchorClick}
				href="#book"
				class="w-full rounded-full bg-tt-red px-8 font-semibold hover:bg-tt-red/90 sm:w-auto lg:text-lg"
				>Check dates & book</Button
			>
			<Button
				data-sveltekit-noscroll
				onclick={handleAnchorClick}
				href="#enquiry"
				variant="outline"
				class="w-full rounded-full border-2 bg-transparent px-8 font-semibold text-background hover:bg-background hover:text-foreground sm:w-auto lg:text-lg"
				>Enquire about this tour</Button
			>
		</div>
	</div>
</section>
